(function () {
  var CART_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  var timer = null;

  function isCartUrl(url) {
    if (typeof url !== 'string') return false;
    for (var i = 0; i < CART_PATHS.length; i += 1) {
      if (url.indexOf(CART_PATHS[i]) !== -1) return true;
    }
    return false;
  }

  function applyCount(count) {
    var badges = document.querySelectorAll('[data-header-cart-count]');
    Array.prototype.forEach.call(badges, function (badge) {
      badge.textContent = String(count);
      badge.setAttribute('data-header-cart-count', String(count));
    });
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') applyCount(cart.item_count);
      })
      .catch(function () {});
  }

  function scheduleRefresh() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(refreshCount, 300);
  }

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url;
      var result = originalFetch.apply(this, arguments);
      if (isCartUrl(url)) {
        result.then(scheduleRefresh, function () {});
      }
      return result;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartUrl(url)) {
      this.addEventListener('loadend', scheduleRefresh);
    }
    return originalOpen.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:updated'].forEach(function (name) {
    document.addEventListener(name, scheduleRefresh);
  });
})();
